import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import SearchPage from '..';
import LoadingIndicator from '../../../components/LoadingIndicator';
import { LeagueTypes, SportTypeIds, LeagueTierTypes } from '../../../utils/types';

const SearchWrapper = () => {
    const { user } = useSelector((state) => state.auth);
    const location = user?.location;
    const { leagueTypeIds } = useParams();
    const { ADULT, JUNIOR } = LeagueTierTypes;
    const { TENNIS, PICKLEBALL } = SportTypeIds;
    const { UT_ADULT_TEAM_PICKLEBALL, UT_ADULT_TEAM_TENNIS, UT_JUNIOR_TEAM_PICKLEBALL, UT_JUNIOR_TEAM_TENNIS } = LeagueTypes;
    const [userLocation, setUserLocation] = useState(null);
    const [selectedSportTypeIds, setSelectedSportTypeIds] = useState(null);
    const [tierTypes, setLeagueTierTypes] = useState(null);

    useEffect(() => {
        if (location?.latLng?.length) {
            const [lat, lng] = location.latLng;
            setUserLocation({ lat, lng });
        }
    }, [location]);

    useEffect(() => {
        if (leagueTypeIds) {
            const leagueIds = leagueTypeIds
                .split(',')
                .map((id) => parseInt(id))
                .filter(Boolean);

            const sports = new Set();
            const tiers = new Set();

            leagueIds.forEach((id) => {
                if (id === UT_ADULT_TEAM_PICKLEBALL || id === UT_JUNIOR_TEAM_PICKLEBALL) {
                    sports.add(PICKLEBALL);
                } else if (id === UT_ADULT_TEAM_TENNIS || id === UT_JUNIOR_TEAM_TENNIS) {
                    sports.add(TENNIS);
                }

                if (id === UT_ADULT_TEAM_PICKLEBALL || id === UT_ADULT_TEAM_TENNIS) {
                    tiers.add(ADULT);
                } else if (id === UT_JUNIOR_TEAM_PICKLEBALL || id === UT_JUNIOR_TEAM_TENNIS) {
                    tiers.add(JUNIOR);
                }
            });

            setSelectedSportTypeIds([...sports]);
            setLeagueTierTypes([...tiers]);
        }
    }, [leagueTypeIds]);

    return !userLocation ? <LoadingIndicator /> : <SearchPage userLocation={userLocation} leagueTypeIds={leagueTypeIds} selectedSportTypeIds={selectedSportTypeIds} leagueTierTypes={tierTypes} />;
};

export default SearchWrapper;
